const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** Sidebar style age: now, 9m, 3h, 2d, then a short date. */
export const shortAge = (then: number, now = Date.now()) => {
  const elapsed = Math.max(0, now - then);
  if (elapsed < MINUTE) return "now";
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)}m`;
  if (elapsed < DAY) return `${Math.floor(elapsed / HOUR)}h`;
  if (elapsed < 7 * DAY) return `${Math.floor(elapsed / DAY)}d`;
  return new Date(then).toLocaleDateString(undefined, { month: "short", day: "numeric" });
};

/** Clock time for message headers: 08:04. */
export const clock = (at: number) =>
  new Date(at).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", hour12: false });

const dayStart = (at: number) => new Date(at).setHours(0, 0, 0, 0);

/**
 * A message's time in the thread: the clock today, and the day in front of it once the
 * message is older, so a two day old reply never reads as this morning's.
 */
export const stamp = (at: number, now = Date.now()) => {
  const days = Math.round((dayStart(now) - dayStart(at)) / DAY);
  const time = clock(at);
  if (days <= 0) return time;
  if (days === 1) return `Yesterday ${time}`;
  const date = new Date(at);
  if (days < 7) return `${date.toLocaleDateString(undefined, { weekday: "short" })} ${time}`;
  const sameYear = date.getFullYear() === new Date(now).getFullYear();
  return `${date.toLocaleDateString(undefined, { month: "short", day: "numeric", ...(sameYear ? {} : { year: "numeric" }) })}, ${time}`;
};
